
import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

export default function AlertDialog(props) {
    const {open , onChangeValue, text, onHandleClose } = props;
    
  return (
    <div>
      <Dialog
        maxWidth="md"
        open={open}
        onClose={onHandleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        
        <DialogContent className={"error-dialog-content"}>
          <DialogContentText id="alert-dialog-description">
            {text}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={onChangeValue} variant="outlined" color="secondary" className="mr-3 ml-3">
            Delete
          </Button>
          <Button onClick={onHandleClose} variant="outlined" color="primary" className="mr-3 ml-3">
            Discard
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
